if (!customElements.get("product-recommendations")) {
  customElements.define(
    "product-recommendations",
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        if ("requestIdleCallback" in window) {
          requestIdleCallback(this.init.bind(this), { timeout: 1500 });
        } else {
          FoxTheme.Motion.inView(this, this.init.bind(this), {
            margin: "0px 0px 400px 0px",
          });
        }

        // Hover logic — uses delegation
        this.addEventListener('mouseover', this.onHover.bind(this));
      }

      init() {
        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((responseText) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(responseText, "text/html")
              .querySelector(".shopify-section");

            if (sectionInnerHTML === null) return;

            const recommendations = sectionInnerHTML.querySelector(
              "product-recommendations"
            );
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;

              // Fire event after replacing content
              this.dispatchEvent(
                new CustomEvent("product-recommendations:loaded", {
                  bubbles: true,
                })
              );
            }

            if (recommendations.querySelector(".product-card")) {
              this.dispatchEvent(new CustomEvent("recommendations:loaded"));
            } else {
              if (
                recommendations.classList.contains("complementary-products")
              ) {
                this.closest(".product__block")?.remove();
              } else {
                this.closest(".shopify-section")?.remove();
              }
              this.dispatchEvent(new CustomEvent("recommendations:empty"));
            }
          })
          .catch((e) => console.error(e));
      }

      onHover(e) {
        const swatch = e.target.closest(".swatch");
        if (!swatch || !this.contains(swatch)) return;

        const primaryImageUrl = swatch.dataset.variantImage;
        const secondaryImageUrl = swatch.dataset.variantSecondImage;
        const productUrl = swatch.dataset.productUrl;

        this.setImage(swatch, primaryImageUrl, secondaryImageUrl, productUrl);

        // Add swatch-active logic
        const productId = swatch.dataset.productId;
        const sectionId = swatch.dataset.sectionId;

        // Remove 'swatch-active' from other swatches of the same product section
        this.querySelectorAll(`.swatch[data-product-id="${productId}"][data-section-id="${sectionId}"]`)
          .forEach((s) => s.classList.remove('swatch-active'));

        // Add 'swatch-active' to current swatch
        swatch.classList.add('swatch-active');
      }

      setImage(swatch, primaryImageUrl, secondaryImageUrl, productUrl) {
        const card = swatch.closest('.product-card__wrapper');
        if (!card) return;
        const primaryImgwrapper = card.querySelector('.product-card__image--main');
        const secondaryImgwrapper = card.querySelector('.product-card__image--second');
        const productUrlElement = card.querySelector('.product-card__link');
        const titleUrlElement = card.querySelector('.product-card__title');    

        const primaryImg = primaryImgwrapper?.querySelector('img');
        if (!primaryImg) return;

        const preloadPrimary = new Image();
        preloadPrimary.src = primaryImageUrl;
        preloadPrimary.onload = () => {
          primaryImg.removeAttribute('srcset');
          if (primaryImg.is === 'image-lazy' && typeof primaryImg.load === 'function') {
            primaryImg.src = primaryImageUrl;
            primaryImg.load();
          } else {
            primaryImg.src = primaryImageUrl;
          }
        };

        const secondaryImg = secondaryImgwrapper?.querySelector('img');
        if (secondaryImg && secondaryImageUrl) {
          const secondaryPrimary = new Image();
          secondaryPrimary.src = secondaryImageUrl;
          secondaryPrimary.onload = () => {
            secondaryImg.removeAttribute('srcset');
            if (secondaryImg.is === 'image-lazy' && typeof secondaryImg.load === 'function') {
              secondaryImg.src = secondaryImageUrl;
              secondaryImg.load();
            } else {
              secondaryImg.src = secondaryImageUrl;
            }
          };
        }

        // Update product URL if present
        if (productUrlElement && productUrl) {
          productUrlElement.href = productUrl;
        }
        if (titleUrlElement && productUrl) {
          titleUrlElement.href = productUrl;
        }
      }
    }
  );
}